




















































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { IBasketRoute } from "@/models/baskets";
import Context from "@/mixins/context";
import { QUERY_PARAMS } from "@/data/constants";
import hash from "object-hash";
import _ from "@/boot/lodash";

@Component({
  components: {
    "basket-provider": () =>
      import("@/components/app/global/baskets/basket/basketProvider.vue"),
    "basket-provisioning-provider": () =>
      import("@/components/app/global/baskets/basket/provisioningProvider.vue"),
    "shop-provider": () =>
      import("@/components/app/global/baskets/basket/shopProvider.vue"),
    "basket-topper": () =>
      import("@/components/app/global/baskets/basket/basketTopper.vue"),
    "basket-notifications": () =>
      import("@/components/app/global/baskets/basket/basketNotifications.vue"),
    "basket-stepper": () =>
      import("@/components/app/global/baskets/basket/basketStepper.vue"),
    "basket-button": () =>
      import("@/components/app/global/baskets/basket/basketButton.vue"),
    "basket-currency-switcher": () =>
      import(
        "@/components/app/global/baskets/basket/basketCurrencySwitcher.vue"
      )
  }
})
export default class Basket extends Mixins(Context) {
  // Props

  @Prop({ required: true })
  public basketRoutes!: IBasketRoute[];

  @Prop({ default: "" })
  public routeClientId!: string | number;

  @Prop({ default: "" })
  public routeAccountId!: string | number;

  @Prop({ default: "" })
  public routeBasketId!: string | number;

  @Prop({ default: "" })
  public routeOrderId!: string | number;

  @Prop({ default: 0 })
  public billingTerm!: number;

  @Prop({ default: 1 })
  public quantity!: number;

  @Prop({ default: "" })
  public routeCurrencyCode!: string;

  @Prop({ default: "" })
  public routeCoupons!: string;

  @Prop({ default: false })
  public routeCrossSell!: boolean;

  @Prop({ default: false })
  public routeReadMore!: boolean;

  /**
   * @desc This key is required to help prevent caching issues when routing
   * directly between two different eg 'productViews'. Without some uniqueness
   * around the basket product id/product id, provision field values etc can be
   * incorrectly associated with the wrong product.
   */

  public get routerViewKey() {
    return hash(
      _.pick(this.$route.query, [
        QUERY_PARAMS.CURRENCY_CODE,
        QUERY_PARAMS.BASKET_PRODUCT_ID,
        QUERY_PARAMS.PRODUCT_ID
      ])
    );
  }
}
